import * as sections from './modules/sections.js'
import * as mmedia from './modules/mmedia.js'
import './sections/index.js'
import './modules/reveal.js'

sections.setParam('containerSelector', 'body')
sections.parse()

mmedia.set('wide', '(min-width: 1441px)')
mmedia.set('large', '(min-width: 1025px) and (max-width: 1440px)')
mmedia.set('medium', '(min-width: 761px) and (max-width: 1024px)')
mmedia.set('small', '(max-width: 760px)')
